import React from 'react'
import Lottie from 'react-lottie'

import { Typewriter } from 'components/TypeWriter'
import * as backgroundAnimationData from 'assets/lottie/lumi/background.json'
import * as introInData from 'assets/lottie/lumi/introIn.json'
import * as successInInData from 'assets/lottie/lumi/successIn.json'

import { Stage } from './../context/LumiContext.types'
import { useLumi } from './../hooks/useLumi'
import * as S from './banner.styles'

const stages = {
    [Stage.Init]: {
        title: 'Hello, I’m Lumi...',
        description:
            'Your partner in crafting inclusive job adverts, illuminating your DEI journey. Simply add your job ads below, and I’ll help turn them into inclusive posts that attract a diverse range of talented applicants.',
        animationIn: introInData,
    },
    [Stage.Processing]: {
        title: 'Transforming your job post(s)',
        description:
            'While you wait, I’ve compiled some helpful tips and tricks to encourage inclusivity in the workplace.',
        animationIn: introInData,
    },
    [Stage.Completed]: {
        title: 'You’re all set!',
        description: 'Your job ads are now more inclusive than ever. Would you like to download?',
        animationIn: successInInData,
    },
}

export const Banner = () => {
    const { stage } = useLumi()

    return (
        <S.BannerWrapper>
            <Lottie
                options={{
                    loop: true,
                    autoplay: true,
                    animationData: backgroundAnimationData,
                    rendererSettings: {
                        preserveAspectRatio: 'xMidYMid slice',
                    },
                }}
                speed={0.25}
                style={{ position: 'absolute', top: 0, bottom: 0, left: 0, right: 0 }}
            />

            <S.Logo>
                <Lottie
                    options={{
                        loop: 1,
                        autoplay: true,
                        animationData: stages[stage].animationIn,
                        rendererSettings: {
                            preserveAspectRatio: 'xMidYMid slice',
                        },
                    }}
                />
            </S.Logo>

            <S.Text key={stage}>
                <S.Title>{stages[stage].title}</S.Title>

                <S.Subtitle>
                    <div>{stages[stage].description}</div>

                    <div>
                        <Typewriter text={stages[stage].description} />
                    </div>
                </S.Subtitle>
            </S.Text>
        </S.BannerWrapper>
    )
}
